import { getAuthToken } from '@/utils/authToken';

const NOTIFY_PATH = '/feifan-xxl-portal/ws/notify';
const taskListeners = new Set();
let socket = null;
let reconnectTimer = null;
let heartbeatTimer = null;
let manuallyClosed = false;
let reconnectDelay = 1000;

function buildWsUrl(token) {
  if (!token || typeof window === 'undefined') return '';
  const configured = String(import.meta.env.VITE_PORTAL_API_BASE_URL || '').replace(/\/$/, '');
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  if (configured && /^https?:/i.test(configured)) {
    return `${configured.replace(/^http/i, 'ws')}${NOTIFY_PATH}?token=${encodeURIComponent(token)}`;
  }
  return `${protocol}//${window.location.host}${NOTIFY_PATH}?token=${encodeURIComponent(token)}`;
}

function announce(message) {
  taskListeners.forEach(listener => listener(message));
  window.dispatchEvent(new CustomEvent('designer-task-updated', { detail: message }));
}

function clearTimers() {
  window.clearTimeout(reconnectTimer);
  window.clearInterval(heartbeatTimer);
  reconnectTimer = null;
  heartbeatTimer = null;
}

function scheduleReconnect() {
  if (manuallyClosed) return;
  window.clearTimeout(reconnectTimer);
  reconnectTimer = window.setTimeout(() => {
    reconnectDelay = Math.min(reconnectDelay * 2, 30000);
    connectDesignerTaskRealtime();
  }, reconnectDelay);
}

export function connectDesignerTaskRealtime() {
  const token = getAuthToken();
  const url = buildWsUrl(token);
  if (!url || socket?.readyState === WebSocket.OPEN || socket?.readyState === WebSocket.CONNECTING) return false;
  manuallyClosed = false;
  socket = new WebSocket(url);
  socket.onopen = () => {
    reconnectDelay = 1000;
    heartbeatTimer = window.setInterval(() => {
      if (socket?.readyState === WebSocket.OPEN) socket.send('ping');
    }, 15000);
  };
  socket.onmessage = event => {
    if (event.data === 'pong') return;
    try {
      const message = JSON.parse(String(event.data));
      if (message?.type === 'DESIGNER_TASK') announce(message);
    } catch { /* ignore malformed notifications */ }
  };
  socket.onclose = () => {
    socket = null;
    clearTimers();
    scheduleReconnect();
  };
  socket.onerror = () => {};
  return true;
}

export function disconnectDesignerTaskRealtime() {
  manuallyClosed = true;
  clearTimers();
  socket?.close();
  socket = null;
}

export function subscribeDesignerTaskNotifications(listener) {
  taskListeners.add(listener);
  return () => taskListeners.delete(listener);
}
